var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 48,
    rx: 6,
    fill: "#0057CC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9055 7H25.9355L34.4363 15.8606V33.0945C34.4363 35.2534 32.6896 37 30.5382 37H15.9055C13.7466 37 12 35.2534 12 33.0945V10.9055C12 8.74662 13.7466 7 15.9055 7Z",
    fill: "#E03303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.929 7V15.7931H34.4372L25.929 7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.716 28.4618V23.012H19.0323C19.602 23.012 20.0593 23.1694 20.4042 23.4918C20.7415 23.8066 20.9139 24.2264 20.9139 24.7586C20.9139 25.2834 20.7415 25.7106 20.4042 26.0255C20.0593 26.3403 19.602 26.4977 19.0323 26.4977H18.1028V28.4618H16.716ZM18.1028 25.3134H18.875C19.0848 25.3134 19.2423 25.2684 19.3622 25.1709C19.4746 25.0735 19.5271 24.9311 19.5271 24.7586C19.5271 24.5787 19.4747 24.4438 19.3622 24.3463C19.2423 24.2489 19.0849 24.1964 18.875 24.1964H18.1028V25.3134ZM21.4986 28.4618V23.012H23.815C24.3847 23.012 24.8419 23.1694 25.1868 23.4918C25.5316 23.8066 25.6965 24.2264 25.6965 24.7586C25.6965 25.2834 25.5316 25.7106 25.1868 26.0255C24.8419 26.3403 24.3847 26.4977 23.815 26.4977H22.8929V28.4618H21.4986ZM22.8929 25.3134H23.6575C23.8674 25.3134 24.0323 25.2684 24.1448 25.1709C24.2572 25.0735 24.3172 24.9311 24.3172 24.7586C24.3172 24.5787 24.2573 24.4438 24.1448 24.3463C24.0323 24.2489 23.8674 24.1964 23.6575 24.1964H22.8929V25.3134ZM27.698 28.4618V24.1964H26.1463V23.012H30.6516V24.1964H29.0923V28.4618H27.698Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptFileIcon);
export default __webpack_public_path__ + "static/media/Ppt_File_Icon.cde9e2d3c5ebe7fb1545ea8d644ee68f.svg";
export { ForwardRef as ReactComponent };